import React from 'react';
import type { DefenseCounsel } from '../../../../../../api/types/rater-x-preset';
import type { DCFormValues } from '../DefenseCounselModal';
import DefenseCounselModal from '../DefenseCounselModal';
import {
  formatDefenseCounselForState,
  getDefaultDefenseCounselValues,
} from '../../amendatory-coverages/line-items/DefenseCounsel';
import type { RaterXModalProps } from './types';

const RaterXDefenseCounselModal = ({ data, close }: RaterXModalProps) => {
  const onSubmit = (formValues: DCFormValues) => {
    const _defenseCounsel = formatDefenseCounselForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: _defenseCounsel,
      },
    });
  };

  return (
    <DefenseCounselModal
      close={close}
      data={{
        onSubmit,
        language: data.language,
        productType: data.productType,
        defaultValues: getDefaultDefenseCounselValues(
          data.coverageState.value as DefenseCounsel
        ),
      }}
    />
  );
};

export const RaterXDefenseCounselModalModalConfig = {
  RaterXDefenseCounselModal: {
    component: RaterXDefenseCounselModal,
    config: {
      title: 'Add/Edit Defense Counsel',
      maxWidth: 'sm',
    },
  },
};
